export default __webpack_public_path__ + "static/media/Halloween.b0bbaad3.mp3";